<template>
  <div class="a-tab">
    <additional-expenses v-if="canEdit"></additional-expenses>

    <div class="a-tab__control u-margin-b-24">
      <button class="a-link a-tab__btn"
               :class="{'a-active': item.id === activeAdditionalExpenses}"
               :disabled="!canSwitch"
               v-for="item of additionalExpenses"
               @click.prevent="switchTab(item.id)">
        {{item.name}}
<!--        <button class="a-accordion__clear-btn a-tab__clear-btn" @click.prevent="onRemoveTabClick(item)">-->
<!--          <img class="a-tab__clear-btn__img" src="@/assets/img/static/tab-close.svg" alt="">-->
<!--        </button>-->
      </button>
    </div>
    <div class="a-tab__open" v-if="activeAdditionalExpenses">
      <additional-bid-rules-table :additionalExpense="activeAdditionalExpenses"
                                  :rules="additionalBidRules"
                                  :can-edit="canEdit"
                                  @edit="onEdit">
      </additional-bid-rules-table>
    </div>

    <confirmation-dialog ref="confirmation" close-on-action></confirmation-dialog>
  </div>
</template>

<script>
  import AdditionalBidRulesTable from './AdditionalBidRulesTable';
  import ConfirmationDialog from "../../../common/dialogs/ConfirmationDialog";
  import AdditionalExpenses from '@/components/admin/catalogs/additional-expenses/Catalog';

  export default {
    components: {
      ConfirmationDialog,
      AdditionalBidRulesTable,
      AdditionalExpenses
    },

    computed: {
      additionalExpenses() {
        return this.$store.getters.additionalExpenses.items;
      },

      additionalBidRules() {
        const additionalBidRules = this.$store.getters.additionalBidRules.items.find(e => e.nomen === this.activeAdditionalExpenses);
        return additionalBidRules && additionalBidRules.rules;
      },

      permissions() {
        return this.$store.getters.currentUser.permissions;
      },

      canEdit() {
        return this.permissions.CAN_VIEW_ADMIN;
      }
    },

    watch: {
      additionalExpenses() {
        if (!this.activeAdditionalExpenses && this.additionalExpenses.length > 0) {
          this.activeAdditionalExpenses = this.additionalExpenses[0].id;
        }
      }
    },

    data: () => ({
      activeAdditionalExpenses: undefined,
      canSwitch: true
    }),

    created() {
      this._fetchAdditionalExpenses();
    },

    methods: {
      async _fetchAdditionalExpenses() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('fetchAdditionalExpensesFromCatalog');
            await this.$store.dispatch('fetchAdditionalBidRulesFromCatalog');
          }
          catch(e) {
            console.error('unable to fetch list of messages from inbox', e);
            this.globalErrorHandler(e);
          }
        })
      },

      switchTab(id) {
        this.activeAdditionalExpenses = id;
      },

      onEdit(editing) {
        this.canSwitch = !editing;
      },

      // onRemoveTabClick(item) {
      //   this.$refs.confirmation.open({
      //     title: 'Удаление дополнительных расходов',
      //     text: `Вы уверены что хотит удалить ${item.name}`,
      //     onConfirm: () => {
      //
      //     }
      //   })
      // }
    }
  }
</script>

<style scoped>
  .a-tab__btn {
    color: #4C4C4C;
    border-bottom: 1px solid transparent;
  }

  .a-tab__btn.a-active {
    color: #E30613;
    border-bottom: 1px solid #E30613;
  }

  .a-tab__clear-btn {
    margin-left: 8px;
  }

  .a-tab__clear-btn__img {
    height: 12px;
  }
</style>
